import React from 'react';
import type { IconProps } from '../types';

/**
 * View-manipulation icons that the base set is missing: rotate-left
 * (counter-clockwise) and flip-vertical. They mirror the look of the existing
 * `tool-rotate-right` / `tool-flip-horizontal` icons and use `currentColor`.
 */

/** Rotate counter-clockwise (rotate left). */
export const IconRotateLeft = (props: IconProps) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M3 3v5h5" />
    <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
  </svg>
);

/** Flip vertical (mirror top-to-bottom). */
export const IconFlipVertical = (props: IconProps) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M21 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v3" />
    <path d="M21 16v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3" />
    <path d="M4 12H2" />
    <path d="M10 12H8" />
    <path d="M16 12h-2" />
    <path d="M22 12h-2" />
  </svg>
);

export default IconRotateLeft;
